
define('template!orderCompositionTabTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="composition-tab-layout">\n  <div class="composition-top-row">\n    <div class="proofsheet-region"></div>\n    <div class="vrps-region"></div>\n  </div>\n\n  ';
 if (exportFileUid) { ;
__p += '\n    <div class="tab-custom-export">\n      <i class="mdi-file-file-download"></i>\n      <span>' +
((__t = ( _.i18n("order.customExport") )) == null ? '' : __t) +
':</span>\n      <a href="' +
((__t = ( customExportUrl )) == null ? '' : __t) +
'">' +
((__t = ( purchaseOrderId )) == null ? '' : __t) +
'_artwork</a>\n      <i class="mdi-action-delete js-delete-custom-export clickable"></i>\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="comments-row">\n    <div class="comment-section">\n      <label>' +
((__t = ( _.i18n("order.dtpComment") )) == null ? '' : __t) +
'</label>\n      <div class="order-product-comment">' +
((__t = ( comment.replace(/[\n]/g, '<br />') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="comment-section">\n      <label>' +
((__t = ( _.i18n("order.internalComment") )) == null ? '' : __t) +
'</label>\n      <textarea class="order-internal-comment">' +
((__t = ( internalComment )) == null ? '' : __t) +
'</textarea>\n    </div>\n  </div>\n\n  ';
 if (additionalVariationImages) { ;
__p += '\n    <div class="additional-images-section">\n      <label>' +
((__t = ( _.i18n('order.additionalVariationImages') )) == null ? '' : __t) +
'</label>\n      <div class="js-additional-variation-images-region"></div>\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="js-print-area-container-region"></div>\n\n  ';
 if (notDesign2) { ;
__p += '\n    <div class="add-print-area-section">\n      <i class="mdi-content-add-circle-outline"></i>\n      <span>' +
((__t = ( _.i18n("common.add") )) == null ? '' : __t) +
'</span>\n      <select class="paName">\n        <option value=""></option>\n        ';
 _.each(printAreas, function(printArea) { ;
__p += '\n          <option value="' +
((__t = ( printArea.id )) == null ? '' : __t) +
'">\n            ' +
((__t = ( printArea.name )) == null ? '' : __t) +
' (' +
((__t = ( (printArea.width + "x" + printArea.height + "mm") )) == null ? '' : __t) +
')\n          </option>\n        ';
 }) ;
__p += '\n      </select>\n    </div>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

